
<div class="d-flex justify-content-center small-margin-top" *ngIf="isLoading().loadingTags">    
    <zint-loader></zint-loader>
</div>

<p *ngIf="!isLoading().loadingTags && (!inputParams.inputTags || inputParams.inputTags.length == 0)" class="small-margin-top text-center">You have not yet created any {{ inputParams.tagTypeString }} tags.</p>

<h5 *ngIf="inputParams.inputTags && inputParams.inputTags.length > 0" class="small-margin-top">Your {{ inputParams.tagTypeString | titlecase }} Tags</h5>

<p *ngIf="inputParams.inputTags && inputParams.inputTags.length > 0 && !hasUserTags">You have not created any tags yet</p>

<table *ngIf="inputParams.inputTags && inputParams.inputTags.length > 0 && hasUserTags" class="table table-striped table-bordered small-margin-top">
    <thead>
        <tr>
            <td>Tag name</td>
            <td *ngIf="isSuperUser">Tag Owner</td>
            <td>Delete tag</td>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let tag of inputParams.inputTags">
            <tr *ngIf="!tag.isOrgTag">
                <td>{{ tag.name }}</td>
                <td *ngIf="isSuperUser"> <span *ngIf="emailOnAccount != tag.owner" class="badge bg-danger" matTooltipPosition="above" matTooltip="Not owned by you. Delete with caution!"><i class="fal fa-exclamation-triangle"></i></span> {{ tag.owner }}</td>
                <td><button class="rounded-btn-base button-dark" data-bs-toggle="modal" data-bs-target="#tagModal" (click)="triggerDeleteTag(tag.id)"><i class="fal fa-trash"></i></button></td>
            </tr>
        </ng-container>
    </tbody>
</table>



<h5 *ngIf="inputParams.inputTags && inputParams.inputTags.length > 0" class="medium-margin-top">{{ inputParams.tagTypeString | titlecase }} Tags Shared Across your Organisation</h5>

<p *ngIf="inputParams.inputTags && inputParams.inputTags.length > 0 && !hasOrganisationTags">There are no shared tags accessible by your account.</p>

<table *ngIf="inputParams.inputTags && inputParams.inputTags.length > 0 && hasOrganisationTags" class="table table-bordered small-margin-top">
    <thead>
        <tr>
            <td>Tag name</td>
            <td *ngIf="isSuperUser" style="min-width: 180px">View Access</td>
            <td *ngIf="isSuperUser" style="min-width: 180px">Edit Access</td>
            <td *ngIf="isSuperUser">Delete tag</td>
        </tr>
    </thead>
    <tbody>
        @for (tag of inputParams.inputTags; track $index) {        
            <tr *ngIf="tag.isOrgTag">
                <td>{{ tag.name }}</td>
                @if(isSuperUser && (inputParams.organisationUsers?.length || inputParams.organisationTeams?.length)){
                    <td>
                        
                        <zint-permissions 
                        [allTeams]="inputParams.organisationTeams"
                        [allUsers]="inputParams.organisationUsers"
                        [existingTeams]="tag.view_teams"
                        [existingUsers]="tag.view_users"
                        (onPermissionChange)="handlePermissionsChange($event, tag.id, 'view')"
                        ></zint-permissions>
                        
                    </td>                        
                
                    <td>
                        <zint-permissions 
                        [allTeams]="inputParams.organisationTeams"
                        [allUsers]="inputParams.organisationUsers"
                        [existingTeams]="tag.edit_teams"
                        [existingUsers]="tag.edit_users"
                        (onPermissionChange)="handlePermissionsChange($event, tag.id, 'edit')"
                        ></zint-permissions>
                    </td>
                }
                @if (isSuperUser && tag.edit_teams && tag.view_teams) {                    
                    <td>
                        <button class="rounded-btn-base button-dark" data-bs-toggle="modal" data-bs-target="#tagModal" (click)="triggerDeleteTag(tag.id)"><i class="fal fa-trash"></i></button>
                    </td>
                }
            </tr>
        
    }
    </tbody>
</table>
